// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_oi-0";
export var animationContainer = "_oi-1";
export var itemPrice = "_oi-a";
export var itemizedContent = "_oi-9";
export var itemizedHeader = "_oi-7";
export var itemizedRow = "_oi-8";
export var itemizedSection = "_oi-6";
export var modalContent = "_oi-2";
export var orderName = "_oi-3";
export var refundOption = "_oi-4";
export var refundOptionsContainer = "_oi-5";
export var shippingLabel = "_oi-b";
export var totalRow = "_oi-c";